/**
 * Fenou – Main Product JS v5
 * Dynamic section order swap, desktop thumbnails, collapsible cards
 * v5: i18n via hidden DOM container (<.fenou-i18n>) so Weglot / translate
 *     tools can translate Button + Stock-Status strings.
 */
(function () {
  document.querySelectorAll('.fenou-section').forEach(initSection);

  function initSection(section) {
    const sid = section.dataset.sectionId;
    if (!sid) return;
    initGalleryMobile(section, sid);
    initGalleryDesktop(section, sid);
    initPurchaseSections(section, sid);
    initPurchaseOptions(section, sid);
    initAccordionPanels(section, sid);
    initAddToCart(section, sid);
    initReviewsScroll(section, sid);
  }

  /* I18N HELPER — reads translated strings from the hidden
   * <.fenou-i18n [data-key=...]> container rendered by the section.
   * Weglot / other client-side translators translate the container on
   * page load; JS picks up the current (possibly translated) textContent.
   * Falls back to provided default if key is missing. */
  function i18n(section, key, fallback, vars) {
    var el = section.querySelector('.fenou-i18n [data-key="' + key + '"]');
    var txt = el && el.textContent ? el.textContent.trim() : (fallback || '');
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        txt = txt.split('[' + k + ']').join(vars[k]);
      });
    }
    return txt;
  }

  /* SMOOTH SCROLL TO REVIEWS SECTION */
  function initReviewsScroll(section, sid) {
    const link = document.getElementById(`fenou-reviewsLink-${sid}`);
    if (!link) return;
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById('fenou-reviews-section');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* GALLERY MOBILE – horizontal swipe with dots + thumbnails */
  function initGalleryMobile(section, sid) {
    var swiper = document.getElementById('fenou-gallerySwipe-' + sid);
    var dotsWrap = document.getElementById('fenou-galleryDots-' + sid);
    var thumbsWrap = document.getElementById('fenou-galleryThumbsMobile-' + sid);
    if (!swiper) return;

    var dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.fenou-gallery-dot')) : [];
    var thumbs = thumbsWrap ? Array.from(thumbsWrap.querySelectorAll('.fenou-gallery-thumb')) : [];
    var slides = Array.from(swiper.querySelectorAll('.fenou-gallery-slide'));
    if (!slides.length) return;

    function setActive(activeIndex) {
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === activeIndex); });
      thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === activeIndex); });
      /* Scroll active thumb into view */
      if (thumbs[activeIndex] && thumbsWrap) {
        thumbs[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function scrollToSlide(idx) {
      var target = slides[idx];
      if (target) swiper.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }

    /* Update on swipe */
    var scrollTimer;
    swiper.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var activeIndex = Math.round(swiper.scrollLeft / slides[0].offsetWidth);
        setActive(activeIndex);
      }, 50);
    }, { passive: true });

    /* Click on dot */
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { scrollToSlide(parseInt(dot.dataset.index, 10)); });
    });

    /* Click on thumbnail */
    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { scrollToSlide(i); });
    });
  }

  /* GALLERY DESKTOP */
  function initGalleryDesktop(section, sid) {
    const badgesDesktop = document.getElementById(`fenou-badgesDesktop-${sid}`);
    const badgesMobile = document.getElementById(`fenou-badgesMobile-${sid}`);

    /* Desktop thumbs */
    const thumbs = document.getElementById(`fenou-galleryThumbs-${sid}`);
    const mainImg = document.getElementById(`fenou-mainImage-${sid}`);
    if (thumbs && mainImg) {
      thumbs.querySelectorAll('.fenou-gallery-thumb').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          mainImg.src = thumb.dataset.fullSrc;
          mainImg.alt = thumb.dataset.alt || '';
          thumbs.querySelectorAll('.fenou-gallery-thumb').forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
          /* Show badges only on first image */
          if (badgesDesktop) {
            badgesDesktop.classList.toggle('is-hidden', thumb.dataset.mediaIndex !== '0');
          }
        });
      });
    }

    /* Mobile thumbs */
    const thumbsMobile = document.getElementById(`fenou-galleryThumbsMobile-${sid}`);
    const mainImgMobile = document.getElementById(`fenou-mainImageMobile-${sid}`);
    if (thumbsMobile && mainImgMobile) {
      thumbsMobile.querySelectorAll('.fenou-gallery-thumb').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          mainImgMobile.src = thumb.dataset.fullSrc;
          mainImgMobile.alt = thumb.dataset.alt || '';
          thumbsMobile.querySelectorAll('.fenou-gallery-thumb').forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
          /* Show badges only on first image */
          if (badgesMobile) {
            badgesMobile.classList.toggle('is-hidden', thumb.dataset.mediaIndex !== '0');
          }
        });
      });
    }
  }

  /* COLLAPSIBLE PURCHASE SECTIONS with order swap */
  function initPurchaseSections(section, sid) {
    const container = document.getElementById(`fenou-purchaseOptions-${sid}`);
    if (!container) return;

    /* Preview bar clicks */
    container.querySelectorAll('.fenou-purchase-preview').forEach((bar) => {
      bar.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const type = bar.dataset.toggle; /* 'abo' or 'onetime' */

        /* Update data-active attribute for CSS order */
        container.setAttribute('data-active', type);

        container.querySelectorAll('.fenou-purchase-section').forEach((sec) => {
          const isAbo = sec.classList.contains('fenou-purchase-section--abo');
          const isOnetime = sec.classList.contains('fenou-purchase-section--onetime');
          const isTarget = (type === 'abo' && isAbo) || (type === 'onetime' && isOnetime);

          if (isTarget) {
            sec.classList.add('is-expanded');
            /* Auto-select default radio if none checked */
            const checkedRadio = sec.querySelector('input[name="fenou_purchase"]:checked');
            if (checkedRadio) {
              checkedRadio.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              /* Check the preferred default (2nd option) or first */
              const allRadios = sec.querySelectorAll('input[name="fenou_purchase"]');
              const target = allRadios.length >= 2 ? allRadios[1] : allRadios[0];
              if (target) {
                target.checked = true;
                target.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          } else {
            sec.classList.remove('is-expanded');
          }
        });

        /* Scroll to show all options after toggle */
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const expandedSection = container.querySelector('.fenou-purchase-section.is-expanded');
            if (expandedSection) {
              const optionsContainer = expandedSection.querySelector('.fenou-onetime-options, .fenou-sub-options');
              const target = optionsContainer || expandedSection;
              const rect = target.getBoundingClientRect();
              const headerOffset = 120; /* space for sticky header */

              /* Only scroll if not fully visible */
              if (rect.top < headerOffset || rect.bottom > window.innerHeight) {
                const scrollTarget = window.scrollY + rect.top - headerOffset;
                window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
              }
            }
          });
        });
      });
    });
  }

  /* PURCHASE OPTIONS – card selection */
  function initPurchaseOptions(section, sid) {
    const radios = section.querySelectorAll('input[name="fenou_purchase"]');
    const variantInput = document.getElementById(`fenou-variantId-${sid}`);
    const spInput = document.getElementById(`fenou-sellingPlanInput-${sid}`);
    const qtyInput = document.getElementById(`fenou-quantityInput-${sid}`);
    const atcPrice = document.getElementById(`fenou-atcPrice-${sid}`);
    if (!radios.length) return;

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (variantInput) variantInput.value = radio.dataset.variantId;
        if (spInput) spInput.value = radio.dataset.sellingPlan || '';
        if (qtyInput) qtyInput.value = radio.dataset.quantity || '1';

        /* Remove selected from ALL cards in the entire purchase options area */
        section.querySelectorAll('.fenou-sub-option').forEach((l) => l.classList.remove('fenou-sub-option--selected'));

        /* Add selected to the clicked card */
        const label = radio.closest('.fenou-sub-option');
        if (label) label.classList.add('fenou-sub-option--selected');

        /* Update ATC price */
        if (atcPrice && radio.dataset.price) {
          atcPrice.textContent = `– ${fmtMoney(parseInt(radio.dataset.price, 10))}`;
        }

        updateAvailability(section, sid, radio.dataset.variantId);
      });
    });

    /* Also handle clicks on labels directly (for browsers where label click doesn't trigger change) */
    section.querySelectorAll('.fenou-sub-option').forEach((label) => {
      label.addEventListener('click', (e) => {
        /* Don't interfere if they clicked the radio itself */
        if (e.target.classList.contains('fenou-sub-radio')) return;
        const radio = label.querySelector('.fenou-sub-radio');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    /* Fire initial change on checked radio */
    const checked = section.querySelector('input[name="fenou_purchase"]:checked');
    if (checked) checked.dispatchEvent(new Event('change'));
  }

  /* AVAILABILITY */
  function updateAvailability(section, sid, vid) {
    const el = section.querySelector('.fenou-productJson');
    if (!el) return;
    try {
      const data = JSON.parse(el.textContent);
      const v = data.variants.find((x) => x.id === parseInt(vid, 10));
      if (!v) return;
      const btn = document.getElementById(`fenou-addToCart-${sid}`);
      const lbl = btn ? btn.querySelector('.fenou-atc-label') : null;
      const stock = document.getElementById(`fenou-stockStatus-${sid}`);
      const restock = section.dataset.restockDate || '';

      if (btn) btn.disabled = false; /* Never disable – always allow purchase */

      if (lbl) {
        if (restock) {
          lbl.textContent = i18n(section, 'preorder', 'Vorbestellen');
        } else {
          lbl.textContent = i18n(section, 'addToCart', 'In den Warenkorb');
        }
      }

      if (stock) {
        if (restock) {
          var preorderText = i18n(section, 'preorderStock', 'Vorbestellbar – Verfügbar ab [DATE]', { DATE: restock });
          stock.innerHTML = '<span class="fenou-stock-indicator fenou-stock-indicator--preorder"></span><span class="fenou-stock-text"></span>';
          stock.querySelector('.fenou-stock-text').textContent = preorderText;
        } else if (v.available) {
          stock.innerHTML = '<span class="fenou-stock-indicator fenou-stock-indicator--in-stock"></span><span class="fenou-stock-text"></span>';
          stock.querySelector('.fenou-stock-text').textContent = i18n(section, 'inStock', 'Auf Lager – Versandfertig in 1-2 Werktagen');
        } else {
          stock.innerHTML = '<span class="fenou-stock-indicator fenou-stock-indicator--out"></span><span class="fenou-stock-text"></span>';
          stock.querySelector('.fenou-stock-text').textContent = i18n(section, 'outOfStock', 'Ausverkauft');
        }
      }
    } catch (e) {}
  }

  function fmtMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00A0\u20AC';
  }

  /* ACCORDION + PANELS */
  function initAccordionPanels(section, sid) {
    const overlay = document.getElementById(`fenou-panelOverlay-${sid}`);
    section.querySelectorAll('.fenou-accordion-trigger').forEach((t) => {
      t.addEventListener('click', () => { if (t.dataset.panelId) openPanel(section, t.dataset.panelId, overlay); });
    });
    section.querySelectorAll('.fenou-slide-panel__close').forEach((b) => {
      b.addEventListener('click', () => closePanels(section, overlay));
    });
    if (overlay) overlay.addEventListener('click', () => closePanels(section, overlay));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePanels(section, overlay); });
  }

  function openPanel(section, id, overlay) {
    closePanels(section, overlay);
    const p = document.getElementById(id);
    if (!p) return;
    p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    document.body.classList.add('fenou-panel-open');
  }

  function closePanels(section, overlay) {
    section.querySelectorAll('.fenou-slide-panel').forEach((p) => { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.classList.remove('is-visible');
    document.body.classList.remove('fenou-panel-open');
  }

  /* ADD TO CART */
  function initAddToCart(section, sid) {
    const form = document.getElementById('fenou-productForm');
    if (!form) return;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = document.getElementById(`fenou-addToCart-${sid}`);
      if (!btn || btn.disabled) return;
      btn.classList.add('is-loading');
      const lbl = btn.querySelector('.fenou-atc-label');
      const orig = lbl ? lbl.textContent : '';
      if (lbl) lbl.textContent = i18n(section, 'loading', 'Wird hinzugefügt...');
      try {
        const fd = new FormData(form);
        const body = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) };
        const sp = fd.get('selling_plan');
        if (sp) body.selling_plan = parseInt(sp, 10);
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [body] }) });
        if (!res.ok) throw new Error();
        if (lbl) lbl.textContent = i18n(section, 'success', 'Hinzugefügt ✓');
        setTimeout(() => { if (lbl) lbl.textContent = orig; btn.classList.remove('is-loading'); }, 1500);
        /* Fetch updated cart and dispatch cart:refresh to open the cart drawer */
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart: cart, openMiniCart: true }
          }));
        });
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
      } catch (err) {
        if (lbl) lbl.textContent = i18n(section, 'error', 'Fehler – erneut versuchen');
        setTimeout(() => { if (lbl) lbl.textContent = orig; btn.classList.remove('is-loading'); }, 2000);
      }
    });
  }
})();